<!-- login -->
<template>
  <div class="container">
    <header>
      <router-link to="/"><img src="./../assets/logo.png" alt=""></router-link>
      <span>欢迎来到广州燊业互联网有限公司</span>
    </header>
    <section class="content">
      <div class="login-wrap">
        <nav class="login-title">
          <span :class="{'left':true,active:!currentIndex}" data-currentIndex="0"  @click="menuChange($event)">账号密码登录</span>
          <span :class="{'right':true,active:currentIndex}" data-currentIndex="1"    @click="menuChange($event)">短信验证码登录</span>
        </nav>
        <form>
          <div class="name">
            <p v-if="!isPhoneLogin"><span>账号:</span><input type="text" placeholder="请输入用户名" /></p>
            <p v-if="!isPhoneLogin"><span>密码:</span><input type="password" placeholder="请输入密码" /></p>
            <p v-if="isPhoneLogin" class="phone"><span>手机号:</span><input  type="text" placeholder="请输入手机号" /><span class="getCode" @click="getCode">获取验证码</span></p>
            <p v-if="isPhoneLogin"><span>验证码:</span><input type="text" placeholder="请输入验证码"/></p>
          </div>
          <button @click="login">登陆</button>
        </form>
        <div class="extra">
          <router-link to="/sign">忘记密码</router-link>
          <router-link class="toSign" to="/sign">还没有账号？立即注册</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
      isPhoneLogin: false
    };
  },
  components: {},
  methods: {
    login: function() {
      console.log("登录");
      this.$router.push({
        path: "/"
      });
    },
    menuChange: function(event) {
      let currentIndex = event.target.dataset.currentindex,
        that = this;
      if (currentIndex == 0) {
        console.log("账号密码登录");
        that.isPhoneLogin = false;
        that.currentIndex = 0;
        console.log(this.currentIndex);
      } else {
        console.log("短信验证码登录");
        that.isPhoneLogin = true;
        that.currentIndex = 1;
        console.log(this.currentIndex);
      }
    },
    getCode: function() {
      console.log("获取验证码");
    }
  }
};
</script>
<style scoped>
.container {
  background-color: #f5f5f5;
}
header {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  background-color: #fff;
}
header img {
  height: 75px;
}
header span {
  color: #00a0e9;
  font-size: 18px;
}
.content {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  background: #fff;
}
.content .login-wrap {
  width: 480px;
  height: 494px;
  font-size: 0;
  margin: 100px 0 246px 0;
  border: 1px solid #e6e6e6;
  display: inline-block;
}
.content .login-wrap .login-title {
  margin-bottom: 73px;
}
.content .login-wrap .login-title .left,
.right {
  display: inline-block;
  width: 240px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-size: 18px;
  color: #333;
}
.content .login-wrap .login-title .left.active,
.right.active {
  background-color: #00a0e9;
  color: #fff;
}
.content .login-wrap .name p {
  margin-bottom: 32px;
  font-size: 18px;
  color: #333;
}
.content .login-wrap .name p input {
  width: 338px;
  height: 48px;
  padding-left: 21px;
  font-size: 18px;
  color: #ccc;
}
.content .login-wrap .name p > span {
  margin-right: 17px;
  font-size: 18px;
}
.content .login-wrap .name .phone {
  position: relative;
}
.content .login-wrap .name .phone .getCode {
  width: 96px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 7px;
  font-size: 14px;
  background: #e6e6e6;
  border-radius: 2px;
  color: #b3b3b3;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  border: 1px solid #ccc !important;
}
::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ccc;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
}
:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #ccc;
}
button {
  width: 230px;
  height: 48px;
  font-size: 18px;
  line-height: 48px;
  text-align: center;
  background-color: #00a0e9;
  border: none;
  color: #fff;
}
.content .login-wrap .extra {
  margin-top: 42px;
}
.content .login-wrap .extra > a {
  font-size: 14px;
  color: #333;
}
.content .login-wrap .extra > a:first-child {
  margin-right: 71px;
}
.content .login-wrap .extra .toSign {
  color: #00a0e9;
}
</style>


// WEBPACK FOOTER //
// src/views/login.vue